import React from 'react';
interface SectionLabelProps {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}
export function SectionLabel({
  children,
  tone = 'light'
}: SectionLabelProps) {
  const isDark = tone === 'dark';
  return <div className="flex items-center gap-3" data-id="element-415" data-mp="2yfvqz5nhkuyq">
      <span className="h-px w-8 bg-metal" aria-hidden="true" data-id="element-416" data-mp="2yczrvdzwk08p" />
      <span className={`text-[11px] font-semibold uppercase tracking-label ${isDark ? 'text-metal-light' : 'text-metal'}`} data-id="element-417" data-mp="33ep6t4q8wy22">
        {children}
      </span>
    </div>;
}